<template>
  <div class="not-found">
    <h1>404 Error</h1>
    <p>Page is not found</p>
  </div>
</template>
